<template>
  <section class="contacts-hero">
    <div class="contacts-hero-background">
      <div class="contacts-hero-overlay"></div>
      <div v-if="backgroundImage" class="contacts-hero-image">
        <picture>
          <source media="(max-width: 767px)" :srcset="backgroundImageMobile" />
          <img :src="backgroundImage" :alt="title" />
        </picture>
      </div>
    </div>
    <div class="contacts-hero-wrapper">
      <div class="contacts-hero-container">
        <div class="contacts-hero-content">
          <h1 class="contacts-hero-title">{{ title }}</h1>
          <IndexBreadcrumbs :current-label="title" class="contacts-hero-breadcrumbs" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()
interface Props {
  title?: string
  backgroundImage?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  backgroundImage: '/assets/images/contacts/contacts-hero-bg.jpg'
})
const title = computed(() => props.title ?? t('pages.contacts.hero.title'))

const backgroundImageMobile = '/assets/images/contacts/contacts-hero-bg-mobile.jpg'
</script>

<style scoped>
.contacts-hero {
  width: 100%;
  position: relative;
  overflow: hidden;
  min-height: 425px;
}

.contacts-hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.contacts-hero-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.contacts-hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right center;
}

.contacts-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(270deg, rgba(255, 173, 46, 0.06) 31%, rgba(23, 218, 149, 1) 64%, rgba(9, 175, 234, 1) 89%);
  z-index: 2;
}

.contacts-hero-wrapper {
  position: relative;
  z-index: 3;
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.contacts-hero-container {
  width: 100%;
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 160px 50px 96px;
}

.contacts-hero-content {
  max-width: 650px;
}

.contacts-hero-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 60px;
  line-height: 1.2;
  color: #fff;
  margin: 0;
}

.contacts-hero-breadcrumbs {
  margin-top: 18px;
}

@media (max-width: 1400px) {
  .contacts-hero-container {
    padding: 140px 50px 80px;
  }

  .contacts-hero-title {
    font-size: 54px;
  }
}

@media (max-width: 1200px) {
  .contacts-hero-image img {
    object-position: -740px center;
  }
}

@media (max-width: 991px) {
  .contacts-hero-container {
    padding: 120px 30px 60px;
  }

  .contacts-hero-title {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  .contacts-hero-overlay {
    top: -48px;
    background: linear-gradient(0deg, rgba(255, 173, 46, 0.06) 31%, rgba(23, 218, 149, 1) 64%, rgba(9, 175, 234, 1) 89%);
  }

  .contacts-hero-image img {
    object-position: right center;
  }

  .contacts-hero-container {
    padding: 42px 20px 50px;
  }

  .contacts-hero-title {
    text-align: center;
    font-size: 35px;
  }
}

@media (max-width: 546px) {
  .contacts-hero-image img {
    object-position: right center;
  }
}
</style>
